import { render, staticRenderFns } from "./Knowledge.vue?vue&type=template&id=495ea2a7&"
import script from "./Knowledge.vue?vue&type=script&lang=ts&"
export * from "./Knowledge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports